var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 8,
    fill: "#006AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5516 13.5999H24.7996L21.3031 10.0999V13.35C21.2786 13.4746 21.378 13.5747 21.5019 13.5999H21.5509H21.5516Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1726 14.8599C21.0016 14.8614 20.8321 14.8288 20.6739 14.7639C20.5157 14.6991 20.372 14.6034 20.2513 14.4823C20.1306 14.3612 20.0352 14.2173 19.9708 14.059C19.9064 13.9006 19.8742 13.731 19.8762 13.56V9.3999H13.0554C12.6426 9.40175 12.2473 9.56689 11.9559 9.85924C11.6644 10.1516 11.5006 10.5474 11.5 10.9602V26.0403C11.5 26.8978 12.2 27.5999 13.0554 27.5999H23.9446C24.3573 27.5981 24.7525 27.433 25.0439 27.1408C25.3353 26.8486 25.4993 26.453 25.5 26.0403V14.8599H21.1726Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.2e5a2e8e.svg";
export { ForwardRef as ReactComponent };